import router from '@/router';
import routes from '../config/routes';

routes.forEach(route => router.addRoute(route));
